import { useTranslation } from 'react-i18next';
import React from 'react';
import { COLOR } from '@src/styles/color';
import GiftIcon from '@src/assets/icons/gift-filled-icon.svg';
import Typography from '@src/new-components/Typography';
import { useSelector } from 'react-redux';
import { calculateReferralStats } from '@src/services/referral';
import { formatNumber } from '@src/utils/number';
import { StyledStatBanner } from './index.style';
import GiftButton from './GiftButton';

const StatBanner = ({ maxRewardCharacter, redeemedCharacters }) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const { language } = i18n;
  const referralConfig = useSelector((state) => state.referralConfig);
  const { charsPerPoint } = referralConfig || {};
  const { user } = useSelector((state) => state.auth);
  const stats = calculateReferralStats(user?.referral, charsPerPoint);

  return (
    <StyledStatBanner>
      <div className="banner-content-container">
        <img src={GiftIcon} alt="gift-icon" className="gift-icon" />
        <div className="banner-content">
          <Typography
            className="banner-content-title"
            variant="body-16-regular"
            color={COLOR.descriptionUpload}
          >
            {t('referralStatsUnclaimedChars')}
          </Typography>
          <Typography
            className="banner-content-value"
            variant="body-24-bold"
            color={COLOR.descriptionGray}
          >
            {formatNumber(stats?.unclaimedChars || 0, language)}
          </Typography>
        </div>
      </div>
      <div className="content-button-container">
        <GiftButton
          maxRewardCharacter={maxRewardCharacter}
          redeemedCharacters={redeemedCharacters}
        />
      </div>
    </StyledStatBanner>
  );
};

export default StatBanner;
